module.exports = __webpack_public_path__ + "logo_rojeca_white.svg?69d2c8b8ce261f32d6444f7f6d8e205a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_rojeca_white.svg
// module id = 34
// module chunks = 0